import axios, { AxiosInstance, AxiosError, AxiosRequestTransformer } from 'axios'

// Function to check if an error is an AxiosError
export function isAxiosError(error: unknown): error is AxiosError {
    return (error as AxiosError).isAxiosError !== undefined;
}

const dateTransformer = (value: any): any => {
    if (value instanceof Date) {
        return value.toISOString();
    }
    if (Array.isArray(value)) {
        return value.map(dateTransformer);
    }
    if (typeof value === 'object' && value !== null) {
        return Object.fromEntries(Object.entries(value).map(([key, value]) => [key, dateTransformer(value)]));
    }
    return value;
}

const apiClient: AxiosInstance = axios.create({
    baseURL: process.env.VUE_APP_PORTAL_API,
    headers: {
        'Content-type': 'application/json',
    },
    transformRequest: [dateTransformer, ...(axios.defaults.transformRequest as AxiosRequestTransformer[])],
});

export default apiClient